import { aboutData } from '@/mocks/home';

export default function AboutSection() {
  return (
    <section id="about" className="py-14 md:py-20 bg-background-50">
      <div className="px-4 md:px-6 max-w-4xl mx-auto">
        <div className="text-center mb-10 md:mb-14">
          <span className="inline-block text-xs font-semibold text-secondary-700 bg-secondary-100 px-3 py-1 rounded-full mb-3">
            品牌介绍
          </span>
          <h2 className="font-heading text-2xl md:text-3xl font-bold text-foreground-900 mb-3">
            {aboutData.title}
          </h2>
          <p className="text-sm text-foreground-500">
            了解天美影视的初心与使命
          </p>
        </div>

        <div className="bg-background-50 border border-background-200/60 rounded-xl p-6 md:p-10">
          <div className="flex flex-col gap-5">
            {aboutData.paragraphs.map((p, idx) => (
              <p key={idx} className="text-sm md:text-base text-foreground-600 leading-relaxed">
                {p}
              </p>
            ))}
          </div>

          <div className="grid grid-cols-2 md:grid-cols-4 gap-4 mt-10 pt-8 border-t border-background-200/60">
            {aboutData.stats.map((stat) => (
              <div key={stat.label} className="text-center">
                <div className="text-xl md:text-2xl font-bold text-primary-600 font-heading">
                  {stat.value}
                </div>
                <div className="text-xs md:text-sm text-foreground-500 mt-1">
                  {stat.label}
                </div>
              </div>
            ))}
          </div>
        </div>
      </div>
    </section>
  );
}